// src/Components/Wizard/generateSummary.js

const AI_LABEL_MAP = {
  face: "顔認識に対応",
  human_vehicle: "人物・車両を検知",
  vca: "動きを自動で検知",
  crowd: "混雑状況の検知に対応",
  human_attribute: "人物属性の識別に対応",
  vehicle_attribute: "車両属性の識別に対応",
  scene_change: "状態変化の検知に対応",
  privacy_guard: "プライバシー保護に対応",
  lpr: "ナンバープレート認識に対応",
  auto_tracking: "自動追尾に対応",
};

const AI_LABEL_ORDER = [
  "face",
  "human_vehicle",
  "vca",
  "crowd",
  "human_attribute",
  "vehicle_attribute",
  "scene_change",
  "privacy_guard",
  "lpr",
  "auto_tracking",
];

export function generateSummary(product) {
  const norm = product?.featuresNormalized || {};

  const mountType = getMountTypeLabel(norm.mountType);
  const connectivity = getConnectivityLabel(norm.connectivity);
  const recordingMethod = getRecordingLabel(norm.recordingMethod);
  const lensType = getLensTypeLabel(norm.lensType);
  const waterproofDustproof = getWaterproofLabel(norm.ipRating);
  const resolution = getResolutionLabel(norm.resolutionMp);
  const lowLightPerformance = getLowLightLabel(norm.lowLightTags);
  const aiFeatures = getAiLabels(norm.aiTags);

  return {
    mountType,
    connectivity,
    recordingMethod,
    lensType,
    waterproofDustproof,
    resolution,
    lowLightPerformance,
    aiFeatures,
  };
}

function getMountTypeLabel(value) {
  switch (value) {
    case "indoor":
      return "屋内専用";
    case "outdoor":
      return "屋外対応";
    case "both":
      return "屋内外対応";
    case "salt":
      return "屋外・塩害地域対応";
    case "special":
      return "特殊環境対応";
    default:
      return "不明";
  }
}

function getConnectivityLabel(tags = []) {
  if (!Array.isArray(tags) || tags.length === 0) return "不明";
  if (tags.includes("wifi")) return "Wi-Fi対応（工事不要）";
  if (tags.includes("poe")) return "LAN接続（PoE対応）";
  if (tags.includes("wired_lan")) return "LAN接続";
  if (tags.includes("analog")) return "アナログ接続";
  if (tags.includes("lte_4g")) return "LTE/4G対応";
  return "不明";
}

function getRecordingLabel(tags = []) {
  if (!Array.isArray(tags) || tags.length === 0) return "不明";
  if (tags.includes("cloud")) return "クラウド保存";
  if (tags.includes("sd")) return "SDカード録画";
  if (tags.includes("nas") || tags.includes("nvr")) return "レコーダー連携";
  if (tags.includes("dvr")) return "同軸レコーダー";
  return "不明";
}

function getLensTypeLabel(value) {
  switch (value) {
    case "ptz":
      return "遠距離ズーム対応";
    case "tele":
      return "遠くをしっかり撮影";
    case "wide":
    case "ultraWide":
    case "fisheye":
      return "広範囲をカバー";
    case "standard":
      return "バランス型";
    default:
      return "不明";
  }
}

function getWaterproofLabel(ipRating) {
  if (ipRating != null) return "防水・防塵対応";
  return "屋内向け";
}

function getResolutionLabel(mp) {
  if (typeof mp !== "number") return "不明";
  if (mp >= 8) return "高画質";
  if (mp >= 5) return "標準画質";
  if (mp > 0) return "最低限画質";
  return "不明";
}

function getLowLightLabel(tags = []) {
  if (!Array.isArray(tags) || tags.length === 0) return "夜間非対応";
  if (tags.includes("white_light")) return "真っ暗でもカラー撮影";
  if (tags.includes("ir_led")) return "夜間撮影対応";
  if (tags.includes("lux")) return "暗所に強い";
  return "夜間撮影対応";
}

function getAiLabels(tags = []) {
  if (!Array.isArray(tags) || tags.length === 0) return ["AI機能なし"];

  const ordered = AI_LABEL_ORDER.filter((tag) => tags.includes(tag))
    .map((tag) => AI_LABEL_MAP[tag])
    .filter(Boolean);

  return ordered.length > 0 ? ordered : ["AI機能あり"];
}
